import React, { useEffect } from "react";
import "../App.css";
import { useOutletContext } from "react-router-dom";

import AboutUsView from "../components/aboutUs/aboutUsView";

export default function AboutUs() {
  const [
    auth,
    setAuth,
    user,
    setUser,
    darkmode,
    setDarkmode,
    nav,
    setNav,
    setError,
  ]: any = useOutletContext();

  useEffect(() => {
    // setNav({ ...nav, page: "profile" });
  }, []);

  return (
    <div className="row">
      <AboutUsView />
    </div>
  );
}
